import React from 'react'
import ReelVideo from '@components/common/ReelVideo/ReelVideo'

const NeedMomizedProductVideo = ({ src, title }) => (
  <div className="flex items-center justify-center bg-black rounded-xl md:rounded-3xl video-wrapper">
    <ReelVideo src={src} title={title} />
  </div>
)

export const ProductVideo = React.memo(
  NeedMomizedProductVideo,
  (prevProps, nextProps) => prevProps.src === nextProps.src
)
